export const BARSCHARTS = [
    {dataKey:'nHoras', fill:'#70AF52'},
]